export enum RmRackTypeEnum {
    Corner = 'corner',
    Center = 'center',
}